import Autocomplete from "@material-ui/lab/Autocomplete"
import { TextField, Typography, Box } from "@material-ui/core"
import { type HourReportFormProjectOption } from "../api/schemas"
import { useTranslation } from "react-i18next"

export const ProjectSelector = ({ projectOptions, selectedProjectId, onChange }: ProjectSelectorProps) => {
  const { t } = useTranslation("hour-report")
  const selectedOption = projectOptions.find((option) => option.id === selectedProjectId)

  return (
    <Box mt={2}>
      <Typography variant="subtitle2" gutterBottom>
        {t("form.project", { defaultValue: "Project" })}
      </Typography>
      <Autocomplete
        options={projectOptions}
        getOptionLabel={(option) => option.title}
        getOptionSelected={(option, value) => option.id === value.id}
        value={selectedOption || null}
        onChange={(event, newValue) => onChange(newValue?.id ?? null)}
        renderInput={(params) => <TextField {...params} variant="outlined" margin="dense" fullWidth />}
      />
    </Box>
  )
}

type ProjectSelectorProps = {
  selectedProjectId: string | null
  onChange: (projectId: string | null) => void
  projectOptions: HourReportFormProjectOption[]
}
